import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';

import { PageOneColumn, PageWithSidebar } from '../../components/Layouts';
import { SidebarContainer } from '../Sidebar';
import { PageHeaderContainer } from '../PageHeader';
import { PostTabsContainer } from '../PostTabs';
import { PostContainer } from '../Post';
import { PostDocumentLinkContainer } from '../PostDocumentLink';
import { PostPollContainer } from '../PostPoll';
import { PostLikesContainer } from '../PostLikes';
import { PostParentsContainer } from '../PostParents';
import { PostAdvertisingLabelContainer } from '../PostAdvertisingLabel';
import { PostStatusLabelContainer } from '../PostStatusLabel';
import { PostRssFeedLinkContainer } from '../PostRssFeedLink';
import { PostCommentsContainer } from '../PostComments';
import { AuthorArticlesNewContainer } from '../AuthorArticles';
import { RecommendedOffersContainer } from '../RecommendedOffers';
import { NothingFound } from '../../components/NotFound';
import { PostCardBodyLayout } from '../../components/PostCardBodyLayout';
import { PostParentsLayout } from '../../components/PostParentsLayout';
import { useEffectOnce } from '../../utils';
import { selectPost } from '../../selectors/post';
import { resetPost } from '../../actions/post';
import { ERequestStatus } from '../../types/requestStatus';
import { TThunkDispatch } from '../../types/redux';

/**
 * Контейнер карточки поста
 */
export const PostCardContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const deviceType = useDeviceType();
  // TODO: пока нет механизма определения типа шаблона
  const layoutType: 'with-sidebar' | 'oneColumn' = 'with-sidebar';
  const Layout: typeof PageOneColumn | typeof PageWithSidebar =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    layoutType === 'oneColumn' ? PageOneColumn : PageWithSidebar;
  const post = useSelector(selectPost);

  useEffectOnce(() => {
    return () => {
      dispatch(resetPost());
    };
  });

  if (ERequestStatus.Failed === post.status) {
    return <NothingFound />;
  }

  const isAuthorArticlesPost = Boolean('id' in post && post.attributes.rubrics?.includes(32));

  return (
    <Layout
      header={<PageHeaderContainer />}
      body={
        <PostCardBodyLayout>
          <PostParentsLayout>
            <PostParentsContainer />
            <PostAdvertisingLabelContainer />
            <PostStatusLabelContainer />
            <PostRssFeedLinkContainer />
          </PostParentsLayout>

          <PostContainer />
          <PostDocumentLinkContainer />
          <PostPollContainer />
          <PostLikesContainer />
          <PostTabsContainer />
          {isAuthorArticlesPost && <AuthorArticlesNewContainer />}
          <RecommendedOffersContainer />
          {!isAuthorArticlesPost && <PostCommentsContainer />}
        </PostCardBodyLayout>
      }
    >
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/*// @ts-ignore*/}
      {layoutType === 'with-sidebar' && deviceType === 'desktop' && <SidebarContainer />}
    </Layout>
  );
};
